<template lang="pug">
div
  p {{$t('kycresetmodal.line1') }}
  p {{$t('kycresetmodal.line2') }}
  p {{$t('kycresetmodal.line3') }}
  button(type="button" @click.prevent="tryToOpen" :disabled="isWorking").btn.btn-success.btn-sm
    template(v-if="!isWorking")  {{$t('Пройти')}}
    template(v-else)
      circle-loader(size="12px")  {{$t('Пройти')}}
  walleto-kyc-reset-warning-modal(ref="warningModal" @kyc-redirect="onKycRedirect" :auto-show="false" @modal-opened="onModalOpened" @modal-canceled="onModalCanceled")
</template>

<script lang="ts">
import Vue from "vue";
import {Component} from "vue-property-decorator";

import WalletoKycResetWarningModal from "./WalletoKycResetWarningModal.vue";
import {OndatoKycStatuses} from "@/views/pages/global/notices/walleto-kyc-modal";
import CircleLoader from "@/components/loaders/CircleLoader.vue";
import {RemoteRequestState} from "@/backoffice/components/pages/taxrules/taxrules";

@Component({
  name: "WalletoKycResetWarningPayoutHint",
  components: {
    WalletoKycResetWarningModal,CircleLoader
  }
})
export default class WalletoKycResetWarningPayoutHint extends Vue{

  redirectUrl = '';

  workingStatus = new RemoteRequestState();

  get isWorking() {
    return this.workingStatus.isLoading;
  }

  tryToOpen() {
    if (this.redirectUrl.length > 0)
    {
      this.workingStatus.loadStart();
      setTimeout(() => {
        this.workingStatus.loadEnd();
      }, 3000);
      (this.$refs.warningModal as WalletoKycResetWarningModal).forceRedirect();
    } else {
      this.workingStatus.loadStart();
      setTimeout(() => {
        this.workingStatus.loadEnd();
      }, 3000);

      (this.$refs.warningModal as WalletoKycResetWarningModal).tryAndOpenModal().catch((err) => {
        this.$emit('open-error', err);
        throw err;
      }).then((result) => {
        if (result.status !== OndatoKycStatuses.REJECTED)
        {
          this.$emit('open-error');
          this.$emit('kyc-not-required');
        } else {
          (this.$refs.warningModal as WalletoKycResetWarningModal).clickMakeFreeKyc();
        }
      });
    }
  }

  onKycRedirect(redirectUrl) {
    this.redirectUrl = redirectUrl;
    setTimeout(() => {
      this.redirectUrl = '';
    }, 3600000);
  }

  onModalOpened() {
    return 0;
  }

  onModalCanceled() {
    return 0;
  }
}
</script>

<style scoped>

</style>

<i18n>
{
  "ru": {
    "kycresetmodal": {
      "title": "Изменения в правилах идентификации (KYC)",
      "line1": "Для граждан вашей страны изменились правила идентификации (KYC).",
      "line2": "Для пополнения и выпуска карт Capitalist вам необходимо пройти идентификацию (KYC) заново.",
      "line3": "Повторная идентификация бесплатна.",
      "submit": "Пройти заново",
      "hint": "Если окно для прохождения идентификации не открылось автоматически, пройдите по {link}.",
      "error": "Не удается получить ссылку на прохождение повторной идентификации (KYC). Попробуйте снова или обратитесь в Службу Поддержки."
    }
  },
  "en": {
    "Пройти": "Go to KYC",
    "ссылке": "link",
    "Напомнить позже": "Remind me later",
    "kycresetmodal": {
      "title": "Changes to the identification rules (KYC)",
      "line1": "Identification rules (KYC) have changed for citizens of your country.",
      "line2": "To be able to replenish or issue Capitalist cards, you have to go through the KYC identification again.",
      "line3": "Re-identification is free of charge.",
      "submit": "Go to identification (KYC)",
      "hint": "If the identification window did not open automatically, follow the {link}.",
      "error": "Error occured while generating KYC re-identification URL. Please try again or contact Support service."
    }
  }
}
</i18n>
